import React, { Suspense } from 'react';
import { CContainer, CSpinner } from '@coreui/react';
import ScenePasscode from './content/ScenePasscode';
import ImportDataPage from './content/importData';
import BackupData from './content/backupData';
import ListUser from './content/ListUser';

// routes config

const AppContent = ({ content }) => {
  return (
    <CContainer className="px-4" lg>
      <Suspense fallback={<CSpinner color="primary" />}>
        {content === 0 && <ListUser />}
        {content === 1 && <ImportDataPage />}
        {content === 2 && <ScenePasscode />}
        {content === 3 && <BackupData />}
      </Suspense>
    </CContainer>
  );
};

export default React.memo(AppContent);
